import React, { useEffect } from "react";
import { inject, observer } from "mobx-react"; // eslint-disable-line
import { Therm, Donors } from "../ui";
import { ErrorMessage, Spinner, TwoKLogo } from "../elements";

const ESCOverlay = (props) => {
  useEffect(() => {
    /* Remove for production */
    const url = `${process.env.REACT_APP_LOCAL_URI}/2k-overlay/`;
    /* Remove for production */

    let streamer = window.location.href.replace(url, "").split("/");
    if (streamer[0][0] === "@" || streamer[0][0] === "+") {
      streamer[2] = streamer[0][0];
      streamer[0] = streamer[0].substr(1, streamer[0].length);
    } else {
      streamer[2] = "@";
    }

    /* Remove for production */
    let streamType = streamer[2] ? streamer[2] : "@",
      username = streamer[0] ? streamer[0] : "warchant",
      slug = streamer[1]
        ? streamer[1]
        : "warchants-2019-playlive-campaign-to-end-childhood-cancer";
    /* Remove for production */
    props.overlayStore.socketConnect(streamType, username, slug);
    //props.userStore.getAccessToken();
  }, [])

  const { error, isLoading } = props.overlayStore;
  //const { accessToken } = props.userStore;

  return error ? (
    <ErrorMessage>THERE HAS BEEN AN ERROR.</ErrorMessage>
  ) : isLoading ? (
    <Spinner />
  ) : (
    <div className="full-overlay-slant">
      <div className="milestone-text-wrap" />
      <TwoKLogo />
      <div className="full-overlay-slant__data left">
        <div className="full-overlay-slant__therm">
          <Therm />
        </div>
        <div className="full-overlay-slant__donors">
          <Donors />
        </div>
      </div>
      {/* <div className="top-container cf">
          <div className="top-container__therm">
            <Therm />
          </div>
        </div>

        <div className="bottom-container">
          <Donors />
        </div> */}

      {/*
            If we return to Oauth, use this.
            !accessToken ? (
              <div>
                <OauthSender
                  authorizeUrl="https://tiltify.com/oauth/authorize"
                  clientId={process.env.REACT_APP_APP_ID}
                  redirectUri="https://localhost:3000"
                  render={({ url }) => <a href={url}>Connect to Tiltify</a>}
                />
              </div>
            ) : (
              <div>
                <button onClick={props.userStore.destroyToken()}>
                  TEMP: Disconnect from Tiltify
                </button>
              </div>
            ) //null
            */}
    </div>
  );
}

export default inject("overlayStore")(observer(ESCOverlay));
